export enum NoteBodyType {
  text = 'text',
}
